import app from "../Config/firebase-config";
import { getAuth, signInWithPopup, GoogleAuthProvider, GithubAuthProvider, signInWithEmailAndPassword, createUserWithEmailAndPassword  } from "firebase/auth"
import { googleProvider, githubProvider} from "../Config/auth-config";
import { baseURL } from "../Config/settings";
import { userContext } from "../App";
import { useContext, useState } from "react";
import "./CSS/Login.css"
import Navbar from './Navbar'

import { toast } from 'react-toastify';

import { useNavigate } from "react-router-dom";
import EmailLogin from "./EmailLogin";

const Login = () => {

  const {user, setUser} = useContext(userContext);
  const [loginForm, setLoginForm] = useState({email: "", password: ""});
  let navigate = useNavigate();

  const auth = getAuth();

const googleSignIn = () => {
    signInWithPopup(auth, googleProvider)
  .then((result) => {
    // This gives you a Google Access Token. You can use it to access the Google API.
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential.accessToken;
    // The signed-in user info.
    const user = result.user;
    setUser(user)
    toast.success('Logged In Successfully', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      });
    navigate('/content')
  })
  .catch((error) => {
    // Handle Errors here.
    const errorCode = error.code;
    const errorMessage = error.message;
    // The email of the user's account used.
    const email = error.email;
    // The AuthCredential type that was used.
    const credential = GoogleAuthProvider.credentialFromError(error);
    // ...
    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
    });
  });

}

const githubSignIn = () => {
    signInWithPopup(auth, githubProvider)
  .then((result) => {
    // This gives you a GitHub Access Token. You can use it to access the GitHub API.
    const credential = GithubAuthProvider.credentialFromResult(result);
    const token = credential.accessToken;

    // The signed-in user info.
    const user = result.user;
    toast.success('Logged In Successfully', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      });
    setUser(user)
    navigate('/content')
  })
  .catch((error) => {
    // Handle Errors here.
    const errorCode = error.code;
    const errorMessage = error.message;
    // The email of the user's account used.
    const email = error.email;

    
      toast.error(errorMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      });
    
    // The AuthCredential type that was used.
    const credential = GithubAuthProvider.credentialFromError(error);
    // ...
  
  });

}

const userSignUp = () => {
  const auth = getAuth();
  createUserWithEmailAndPassword(auth, loginForm.email, loginForm.password)
  .then((userCredential) => {
    // Signed in 
    const user = userCredential.user;
    // ...
      toast.success('Logged In Successfully', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      });
    setUser(user)
    navigate('/content')
  })
  .catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
    // ..
    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      });
  });
}

const testUserLogin = () => {
  const auth = getAuth();
signInWithEmailAndPassword(auth, loginForm.email, loginForm.password)
  .then((userCredential) => {
    // Signed in 
    const user = userCredential.user;
    // ...
    // alert('Logged In')
    toast.success('Logged In Successfully', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      });
    setUser(user)
    navigate('/content')
  })
  .catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
    // ..
    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      });
  });
}

    return (
      <>
        <Navbar></Navbar>
        <div className="login-page">
            <div className="main-login-container">
              <EmailLogin loginForm={loginForm} setLoginForm={setLoginForm} handleSubmit={testUserLogin} userSignUp={userSignUp}></EmailLogin>
            </div>
            <span className="horizontal-line-container">
              <hr className="horizontal-line" />
              <span style={{color: 'black', display: 'inline-block', textAlign: 'center', width: '50px'}}>OR</span>
              <hr className="horizontal-line" />
            </span>

            <div className="button-container">
              <button className="oauth-button" onClick={googleSignIn}>Sign In With Google</button>
              {/* <img src="https://res.cloudinary.com/blankc/image/upload/v1642857321/8276844841530103314_iegzzh.svg" onClick={googleSignIn} alt="" /> */}
            </div>
            <div className="button-container">
              <button className="oauth-button" onClick={githubSignIn}>Sign In With Github</button>
              {/* <img src="https://res.cloudinary.com/blankc/image/upload/v1642857345/18282280761580802960_uk6vhn.svg" onClick={githubSignIn} alt="" /> */}
            </div>
        </div>
      </>
    )
}

export default Login
